export default {
  title: "Company numbers",
  input: {
    coc: "CoC",
    vat: "VAT",
  },
  button: {
    save: "Save",
  },
  api: {
    patched: "Company numbers saved",
    chamberOfCommerce: {
      notNull: "Fill your chamber of commerce number"
    },
    vat: {
      notNull: "Fill your VAT number"
    }
  },
}
